module.exports = __webpack_public_path__ + "img/Withdraw-gold.de73ad3a.svg";